"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect, useState } from "react";
import WavesListSearch from "./WavesListSearch";
import { AuthContext } from "@/components/auth/Auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { PlusIcon } from "@heroicons/react/24/outline";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
export default function WavesListHeader(t0) {
  const $ = _c(32);
  const {
    title: t1,
    identity,
    waveName,
    showCreateNewButton,
    onCreateNewWave,
    onCreateNewDirectMessage,
    setIdentity,
    setWaveName
  } = t0;
  const title = t1 === undefined ? "Waves" : t1;
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  let t2;
  if ($[0] !== activeProfileProxy || $[1] !== connectedProfile?.handle) {
    t2 = () => !!connectedProfile?.handle && !activeProfileProxy;
    $[0] = activeProfileProxy;
    $[1] = connectedProfile?.handle;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const getShowMyWavesButton = t2;
  const [showMyWavesButton, setShowMyWavesButton] = useState(getShowMyWavesButton());
  let t3;
  if ($[3] !== getShowMyWavesButton) {
    t3 = () => setShowMyWavesButton(getShowMyWavesButton());
    $[3] = getShowMyWavesButton;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== activeProfileProxy || $[6] !== connectedProfile) {
    t4 = [connectedProfile, activeProfileProxy];
    $[5] = activeProfileProxy;
    $[6] = connectedProfile;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== title) {
    t5 = <h1>{title}</h1>;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== identity || $[11] !== setIdentity || $[12] !== setWaveName || $[13] !== waveName) {
    t6 = <WavesListSearch identity={identity} waveName={waveName} setWaveName={setWaveName} setIdentity={setIdentity} />;
    $[10] = identity;
    $[11] = setIdentity;
    $[12] = setWaveName;
    $[13] = waveName;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== connectedProfile || $[16] !== setIdentity || $[17] !== showMyWavesButton) {
    t7 = showMyWavesButton && <SecondaryButton onClicked={() => connectedProfile?.handle && setIdentity(connectedProfile.handle)}>My Waves</SecondaryButton>;
    $[15] = connectedProfile;
    $[16] = setIdentity;
    $[17] = showMyWavesButton;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== onCreateNewDirectMessage || $[20] !== onCreateNewWave || $[21] !== showCreateNewButton) {
    t8 = showCreateNewButton && <><PrimaryButton onClicked={onCreateNewWave} loading={false} disabled={false}><PlusIcon className="tw-w-5 tw-h-5 -tw-ml-1" /><span className="tw-hidden sm:tw-inline">Create </span>Wave</PrimaryButton><PrimaryButton onClicked={onCreateNewDirectMessage} loading={false} disabled={false}><FontAwesomeIcon icon={faPaperPlane} className="tw-size-4 tw-flex-shrink-0" /><span className="tw-hidden sm:tw-inline">Create </span>DM</PrimaryButton></>;
    $[19] = onCreateNewDirectMessage;
    $[20] = onCreateNewWave;
    $[21] = showCreateNewButton;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t7 || $[24] !== t8) {
    t9 = <div className="tw-flex tw-gap-3 tw-items-center">{t7}{t8}</div>;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t6 || $[27] !== t9) {
    t10 = <div className="tw-mt-4 md:tw-mt-6 tw-flex tw-flex-col lg:tw-flex-row tw-w-full lg:tw-items-center tw-justify-between tw-gap-4">{t6}{t9}</div>;
    $[26] = t6;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t5) {
    t11 = <div className="tw-mt-4 md:tw-mt-8">{t5}{t10}</div>;
    $[29] = t10;
    $[30] = t5;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}